export { Progress } from "@mantine/core";
export * from "./Progress.config";
